module.exports = __webpack_public_path__ + "img/activ_naked.bc436968.svg";